import { render, staticRenderFns } from "./ReviewPageTab.vue?vue&type=template&id=d9cde9a4&scoped=true&lang=pug&"
import script from "./ReviewPageTab.vue?vue&type=script&lang=js&"
export * from "./ReviewPageTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cde9a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
